import React from 'react';
import {constants} from '@neosvoc/nv-platform-core-common';
import SingleChoice from './widgets/SingleChoice';
import MultipleChoice from './widgets/MultipleChoice';
import NumberWidget from './widgets/NumberWidget';
import SingleChoiceBattery from './widgets/SingleChoiceBattery';
import GeneratorSentimentAnalysis from './widgets/GeneratorSentimentAnalysis';
import GeneratorEntityExtractionWidget from './widgets/GeneratorEntityExtractionWidget';
import GeneratorNPSWidget from './widgets/GeneratorNpsWidget';
import InstanceCompletedAtWidget from './widgets/InstanceCompletedAtWidget';
import SurveySentStatsWidget from './widgets/SurveySentStatsWidget';
import SurveyStatsWidget from './widgets/SurveyStatsWidget';
import ChannelStatsWidget from './widgets/ChannelStatsWidget';
import GeoWidget from './widgets/GeoWidget';
import SingleChoiceWithMax from './widgets/SingleChoiceWithMax';
import RankWidget from './widgets/RankWidget';

const mapping = {
    [constants.WIDGET_TYPES.CHANNEL_STATS]: ChannelStatsWidget,
    [constants.WIDGET_TYPES.GENERATOR_ENTITY_EXTRACTION]: GeneratorEntityExtractionWidget,
    [constants.WIDGET_TYPES.GENERATOR_NPS]: GeneratorNPSWidget,
    [constants.WIDGET_TYPES.GENERATOR_SENTIMENT_ANALYSIS]: GeneratorSentimentAnalysis,
    [constants.WIDGET_TYPES.MULTIPLE_CHOICE]: MultipleChoice,
    [constants.WIDGET_TYPES.NUMBER]: NumberWidget,
    [constants.WIDGET_TYPES.INSTANCE_COMPLETED_AT]: InstanceCompletedAtWidget,
    [constants.WIDGET_TYPES.SINGLE_CHOICE]: SingleChoice,
    [constants.WIDGET_TYPES.SINGLE_CHOICE_BATTERY]: SingleChoiceBattery,
    [constants.WIDGET_TYPES.MULTIPLE_CHOICE_BATTERY]: MultipleChoice,
    [constants.WIDGET_TYPES.SURVEY_SENT_STATS]: SurveySentStatsWidget,
    [constants.WIDGET_TYPES.SURVEY_STATS]: SurveyStatsWidget,
    [constants.WIDGET_TYPES.GEO]: GeoWidget,
    [constants.WIDGET_TYPES.MULTIPLE_NUMBER3_BATTERY]: SingleChoiceWithMax,
    [constants.WIDGET_TYPES.RANK]: RankWidget,
};

const WidgetContent = ({data, error, params, type, hints, instanceType, updateSurveyStatsFromWidget}) => {
    if (error) {
        return <div className="alert alert-danger">An error occurred: {'' + error}</div>;
    }
    if (mapping[type]) {
        const Component = mapping[type];
        return <Component data={data} params={params} hints={hints} instanceType={instanceType} updateSurveyStatsFromWidget={updateSurveyStatsFromWidget} />;
    }
    return <div className="alert alert-danger">Invalid widget type: {type}</div>;
};

export default WidgetContent;
